import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { MyContext } from './MyContext';
import Login from './pages/Login';
import Clientes from './pages/Clientes';
import CadastroCliente from './pages/CadastroCliente';
import Produtos from './pages/Produtos';
import Checkout from './pages/Checkout';
import Perfil from './pages/Perfil';
import Vendas from './pages/Vendas';
import DetalhesPedido from './pages/DetalhesPedido';
import ImgProdutos from './pages/ImgProdutos';
import LayoutWithBottomNav from './components/LayoutWithBottomNav';
import PrivateRoute from './components/PrivateRoute';

function MyRoutes(){
    const { isAuthenticated } = useContext(MyContext);

    return (
        <BrowserRouter>
            <Routes>
                <Route 
                    path="/" 
                    element={
                        isAuthenticated ? <Navigate to="/clientes" replace /> : <Login />
                    } 
                />

                <Route element={<LayoutWithBottomNav />}>
                    <Route
                        path="/clientes"
                        element={
                            <PrivateRoute>
                                <Clientes />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/checkout"
                        element={
                            <PrivateRoute>
                                <Checkout />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/perfil"
                        element={
                            <PrivateRoute>
                                <Perfil />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/produtos"
                        element={
                            <PrivateRoute>
                                <Produtos />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/clientes/cadastro"
                        element={
                            <PrivateRoute>
                                <CadastroCliente />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/pedidos"
                        element={
                            <PrivateRoute>
                                <Vendas />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/pedidos/detalhe"
                        element={
                            <PrivateRoute>
                                <DetalhesPedido />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/img_produtos"
                        element={
                            <PrivateRoute>
                                <ImgProdutos />
                            </PrivateRoute>
                        }
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default MyRoutes;